// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"6959f748","915":"9b2f826d"}[chunkId] + ".chunk.js";
};